import { makeStyles } from "@mui/styles";

export interface LegendComponentProps {
  legends: Legend[];
}

interface Legend {
  hex: string;
  text: string;
}

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  legendGroup: {
    flexDirection: "row",
    display: "inline-block",
    marginRight: 12,
  },
  legendCircle: {
    margin: "0 8px 2px 0",
    display: "inline-block",
    height: 8,
    width: 8,
    borderRadius: 4,
  },
  legendText: {
    display: "inline-block",
    fontSize: "0.8750em",
    color: "#484848",
    letterSpacing: -0.07,
  },
}));

export const CardLegend = ({ legendProps }: { legendProps: LegendComponentProps }) => {
  const classes = useStyle();
  const legends = legendProps.legends;

  const LegendComponent = (legend: Legend) => {
    const hex = legend.hex?.includes("#") ? legend.hex : "#E8E8E8";
    const text = legend.text ? legend.text : "";

    return (
      <div className={classes.legendGroup}>
        <span
          className={classes.legendCircle}
          style={{
            backgroundColor: hex,
          }}
        />
        <p className={classes.legendText}>{text}</p>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      {legends?.length > 0 &&
        legends.map((legend) => {
          return <LegendComponent key={legend.text} {...legend} />;
        })}
    </div>
  );
};
